<template>
	<div>
		<a-spin :tip="spinnerLoaderLabel" size="large" :spinning="spinnerLoader">
			<div class="card">
				<div class="card-body">
					<div class="row">
						<div class="col-md-6">
							<h5 class="mb-4">
								<strong>Catálogo de CFDI</strong>
							</h5>
						</div>
						<!-- <div class="col-md-6 text-right">
							<a-button class="btn btn-info" icon="plus" @click="onAddRecord()" v-if="isUserAdmin">Añadir</a-button>
							<a-button class="btn btn-success ml5" icon="reload" @click="onReload()" />
						</div> -->
					</div>

					<a-table :columns="columns" :dataSource="useOfCfdiList" rowKey="id">
						<span slot="active" slot-scope="record">
							<a-tag color="green" v-if="record.active">Activo</a-tag>
							<a-tag color="red" v-else>Inactivo</a-tag>
						</span>
						<span slot="action" slot-scope="record">
							<!-- <a-button type="info" size="small" icon="edit" @click="onEditRecord(record)" /> -->
							<a-button class="ml5" size="small" :icon="record.active ? 'minus-circle' : 'plus-circle'" @click="onToggleRecord(record.id, record.active)" />
						</span>
					</a-table>
				</div>
			</div>
		</a-spin>
		<insertOrUpdateUseOfCfdi :visible="modal.visible" :title="modal.title" :payload="modal.payload" @closeModal="onCloseModal" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'
import _ from 'lodash'
import insertOrUpdateUseOfCfdi from '@/components/insertOrUpdateUseOfCfdi'

export default {
	name: 'useOfCfdi',
	components: {
		insertOrUpdateUseOfCfdi,
	},
	data() {
		return {
			columns: [
				{
					title: 'ID',
					dataIndex: 'id',
					align: 'center',
				},
				{
					title: 'Clave del SAT',
					dataIndex: 'sat_key',
					align: 'center',
				},
				{
					title: 'Descripción',
					dataIndex: 'description',
				},
				{
					title: 'Estatus',
					scopedSlots: { customRender: 'active' },
					align: 'center',
				},
			],
			modal: {
				visible: false,
				title: '',
				payload: {},
			},
		}
	},
	computed: {
		...mapGetters('user', ['user']),
		...mapGetters('useOfCfdi', ['useOfCfdiList']),
		spinnerLoaderLabel() {
			return this.$store.state.useOfCfdi.spinnerLoaderLabel
		},
		spinnerLoader() {
			return this.$store.state.useOfCfdi.spinnerLoader
		},
		isUserAdmin() {
			return this.user.is_admin ? true : false
		},
	},
	beforeMount() {
		if (this.isUserAdmin) {
			this.columns.push({
				title: 'Acciones',
				scopedSlots: { customRender: 'action' },
				align: 'right',
			})
		}
	},
	mounted() {
		if (this.useOfCfdiList.length == 0) {
			this.initModule()
		}
	},
	methods: {
		initModule() {
			this.$store.dispatch('useOfCfdi/GET')
		},
		onReload() {
			this.initModule()
		},
		onAddRecord() {
			this.modal = {
				visible: true,
				title: 'Añadir registro de una CFDI',
				payload: {},
			}
		},
		onEditRecord(record) {
			this.modal = {
				visible: true,
				title: 'Editar registro de CFDI',
				payload: _.cloneDeep(record),
			}
		},
		onToggleRecord(id, status) {
			Swal.fire({
				title: 'Atención',
				text: `¿Desea ${status ? 'deshabilitar' : 'habilitar'} el registro?`,
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Sí, continuar',
				cancelButtonText: 'Cancelar',
			}).then((result) => {
				if (result.isConfirmed) {
					if (status) {
						this.$store.dispatch('useOfCfdi/DISABLE', id)
					} else {
						this.$store.dispatch('useOfCfdi/ENABLE', id)
					}
				}
			})
		},
		onCloseModal() {
			this.modal.visible = false
		},
	},
}
</script>